import React, { useState, useEffect } from "react";
import UserSettingsAPI from "../../services/UserSettingsAPI";
import { useTranslation } from "../../../../i18n/LanguageContext";

const LocalizationSettings = () => {
  const {
    t,
    language: ctxLanguage,
    setLanguage: setCtxLanguage,
  } = useTranslation();

  const [language, setLanguage] = useState(ctxLanguage || "en");
  const [timezone, setTimezone] = useState("america/new_york");
  const [dateFormat, setDateFormat] = useState("mm-dd-yyyy");

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const data = await UserSettingsAPI.getSettings();
        if (data) {
          // Show the saved backend preference in the dropdown.
          // Intentionally does NOT call setCtxLanguage — opening this panel
          // must not change the active language the user has selected.
          setLanguage(data.language || "en");
          setTimezone(data.timezone || "america/new_york");
          setDateFormat(data.dateFormat || "mm-dd-yyyy");
        }
      } catch (err) {
        console.error("LocalizationSettings: Error loading settings", err);
        setLanguage(localStorage.getItem("language") || "en");
        setTimezone(localStorage.getItem("timezone") || "america/new_york");
        setDateFormat(localStorage.getItem("dateFormat") || "mm-dd-yyyy");
      }
    };
    loadSettings();
  }, []);

  const handleChange = async (field, value, setter) => {
    const oldValue =
      field === "language"
        ? language
        : field === "timezone"
          ? timezone
          : dateFormat;
    setter(value);

    // Switch the UI language immediately so the user sees the effect
    // without waiting for the backend round-trip.
    if (field === "language") {
      setCtxLanguage(value);
    }

    try {
      await UserSettingsAPI.updateSettings({ [field]: value });
    } catch (err) {
      console.error(`Failed to save ${field}`, err);
      setter(oldValue);
      if (field === "language") {
        setCtxLanguage(oldValue);
      }
    }
  };

  return (
    <>
      <div className="common-form-group">
        <h4>{t("localization.heading")}</h4>
        <div className="common-form-row indented-below-h4">
          <div className="common-form-field">
            <label>{t("localization.language")}</label>
            <select
              value={language}
              onChange={(e) =>
                handleChange("language", e.target.value, setLanguage)
              }
            >
              <option value="en">{t("localization.lang.enUS")}</option>
              <option value="es">{t("localization.lang.es")}</option>
            </select>
          </div>
          <div className="common-form-field">
            <label>{t("localization.timezone")}</label>
            <select
              value={timezone}
              onChange={(e) =>
                handleChange("timezone", e.target.value, setTimezone)
              }
            >
              <option value="america/new_york">
                {t("localization.tz.eastern")}
              </option>
              <option value="america/chicago">
                {t("localization.tz.central")}
              </option>
              <option value="america/denver">
                {t("localization.tz.mountain")}
              </option>
              <option value="america/los_angeles">
                {t("localization.tz.pacific")}
              </option>
            </select>
          </div>
        </div>
        <div className="common-form-row indented-below-h4">
          <div className="common-form-field">
            <label>{t("localization.dateFormat")}</label>
            <select
              value={dateFormat}
              onChange={(e) =>
                handleChange("dateFormat", e.target.value, setDateFormat)
              }
            >
              <option value="mm-dd-yyyy">MM/DD/YYYY</option>
              <option value="dd-mm-yyyy">DD/MM/YYYY</option>
              <option value="yyyy-mm-dd">YYYY-MM-DD</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocalizationSettings;
